module.exports = __webpack_public_path__ + "static/00002.d52ef4b3.jpg";